import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { BotService } from './_bot.service';

@Component({
    selector: 'bot_',
    templateUrl: '_bot.component.html',
    styleUrls: ['./_bot.component.scss'],
    // encapsulation: ViewEncapsulation.None
})

export class BotComponent {

    // recebe objeto mensage vindo do servico
    public conversation;

    /**
     * parametro para identificar o contexto do bot ( contextual || window )
     * repassa para a diretiva
     */
    @Input() public contextual: boolean = false;

    constructor(
        public botService: BotService,
    ) {
        botService.startConversation();
        botService.queueConversation$.subscribe((msg) => {
            this.conversation = msg;
        });
    }
}
